<template>
  <el-dialog title="联系人信息" :visible.sync="innerVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false"
             append-to-body open>
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="姓名" :label-width="formLabelWidth" prop="uname">
            <el-input v-model="form.uname" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="手机号" :label-width="formLabelWidth" prop="mobile">
            <el-input v-model="form.mobile" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="职务" :label-width="formLabelWidth" prop="title">
            <el-input v-model="form.title" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="负责人" :label-width="formLabelWidth" prop="mainlink">
            <el-radio-group v-model="form.mainlink">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="form.mainlink==0">
        <el-col :span="24">
          <el-form-item label="岗位权限" :label-width="formLabelWidth" prop="school">
            <el-checkbox-group v-model="gwlist">
              <el-checkbox :label="'1'">查看价格</el-checkbox>
              <el-checkbox :label="'2'">订单付款</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11">
          <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
            <el-input v-model="form.email" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="QQ" :label-width="formLabelWidth" prop="qq">
            <el-input v-model="form.qq" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="false">
        <el-col :span="11">
          <el-form-item label="籍贯" :label-width="formLabelWidth" prop="birthplace">
            <el-input v-model="form.birthplace" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="生日" :label-width="formLabelWidth" prop="birthday">
            <el-date-picker style="width:100%"
                            v-model="form.birthday"
                            type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="false">
        <el-col :span="11">
          <el-form-item label="毕业学校" :label-width="formLabelWidth" prop="school">
            <el-input v-model="form.school" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="毕业年份" :label-width="formLabelWidth" prop="graduateyearmonth">
            <el-input v-model="form.graduateyearmonth" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth" prop="school">
             <span  @click="lookQRcode" style="cursor: pointer;"
                     v-if="form.uguid">查看二维码</span>
          </el-form-item>
        </el-col>
      </el-row>

      <el-collapse-item name="2" v-if="isShowSupplier">
        <template slot="title" style="width: 1160px;display: inline-block;">
            <span class="titlecolor">客户
            <el-button size="small" type="text" v-on:click.stop="selExternal"
                       style="margin-right: 50px;float: right">新增</el-button>
            </span>
        </template>
        <el-row :gutter="20">
          <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                 class="query-table">
            <tr>
              <td style="width: 150px;background-color: #F4F4F4;text-align: center;" class="center">编码</td>
              <td style="background-color: #F4F4F4;  text-align: center;" class="center">姓名</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
            </tr>
            <tr v-for="(item,index) in customers">
              <td class="content">
                {{item.customerserial}}
              </td>
              <td class="content">
                {{item.deptname}}
              </td>
              <td class="content">
                <el-button @click="customerDelete(index,item)" type="text"
                           size="small">删除
                </el-button>
              </td>
            </tr>
          </table>
        </el-row>
      </el-collapse-item>
    </el-form>
    <ExternaldeptSel ref="externalsel" :unitgroup="1" :title="'选择客户'" @select="selectExternalDept"></ExternaldeptSel>
    <ExternaldeptcontactorQRcode ref="ExternaldeptcontactorQRcode" ></ExternaldeptcontactorQRcode>

    <div slot="footer" class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData1">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getDetail} from "@/api/set/externaldept";
  import {attUUID} from '@/api/attachment';
  import ExternaldeptSel from '../externaldept/ExternaldeptSel'
  import ExternaldeptcontactorQRcode from '../externaldept/ExternaldeptcontactorQRcode'


  export default {
    name: "ExternaldeptcontactorEdit",
    data() {
      return {
        sex: '0',
        innerVisible: false,
        activeNames: ['1', '2', '3'],
        AllData: [],
        EditIndex: -1,
        isShowSupplier: "",//是否需要选择供应商
        customers: [],//联系人关联的门店信息
        gwlist:[],//选中的岗位权限
        form: {  //表单数据
          mainlink: 0,
          uguid: '',
          uname: '',
          mobile: '',
          title: '',
          sex: '',
          birthplace: '',
          birthDay: '',
          email: '',
          qq: '',
          school: '',
          graduateyearmonth: '',
          hobbies: '',
          address: '',
          dguid: '',
          customerserial: '',
          customername: '',
          customersString: '',
          gwright:"",//岗位权限
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          uname: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            // {pattern: /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      showContactor(unitguid, TableData) {
        this.customers = []
        this.isShowSupplier = false;
        this.form.dguid = unitguid;
        this.AllData = TableData;
        this.innerVisible = true
      },
      saveData1() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            var CanPost = true;
            for (var i = 0; i < this.AllData.length; i++) {
              var da = this.AllData[i];
              if (da.uguid != this.form.uguid) {
                if (da.mobile == this.form.mobile) {
                  this.$message.error({message: '手机号不能重复！'});
                  CanPost = false;
                  return;
                }
                if (da.uname == this.form.uname) {
                  this.$message.error({message: '姓名不能重复！'});
                  CanPost = false;
                  return;
                }
              }
            }
            if (CanPost) {
              if (this.EditIndex == -1)
                this.form.uguid = attUUID();

              if(this.gwlist.length>0) {//岗位权限
                this.form.gwright =this.gwlist.join(';')
              }else{
                this.form.gwright=""
              }
              for(let i in this.customers){
                this.customers[i]["contactorguid"]=this.form.uguid
              }
                this.form.customersString=JSON.stringify(this.customers)
              this.$emit('AfterEditContactor', this.EditIndex, this.form);
              this.innerVisible = false;
            }
          }
        });
      },
      //查看二维码
      lookQRcode(){
        this.$refs.ExternaldeptcontactorQRcode.show(this.form)
      },
      initContactorData(index, rowdata) {
        this.EditIndex = index;
        for (var p in this.form) {//遍历json对象的每个key/value对,p为key
          this.form[p] = rowdata[p];
        }
        if(this.form.gwright){
          this.gwlist=this.form.gwright.split(';')
        }else
          this.gwlist=['2'];
        if(this.form.customersString){
          this.customers=JSON.parse(this.form.customersString)
        }
      },
      // selectExternalDept(customerserial, deptname, row) {
      //   this.form.customerserial = customerserial;
      //   this.form.customername = deptname;
      // },

      selectExternalDept(customerserial, deptname, row) {//联系人编辑完成
        var NewItem = {};
        for (var p in row) {//遍历json对象的每个key/value对,p为key
          NewItem[p] = row[p];
        }
        this.customers.splice(this.customers.length, 1, NewItem);
      },
      customerDelete(index, row) {
        this.customers.splice(index, 1)
      },
      selExternal() {
        this.$refs.externalsel.show()
      },
      initFormContactor() {
        if (this.$refs.form1 !== undefined) {
          for (var p in this.form) {//遍历json对象的每个key/value对,p为key
            this.form[p] = '';
          }
          this.gwlist = ['2']
          this.form.mainlink = 0;
          this.EditIndex = -1;
        }
      }
    },
    mounted() {
    },
    components: {
      ExternaldeptSel,
      ExternaldeptcontactorQRcode
    },
  }
</script>


<style scoped>
  .titlecolor {
    color: #20A0FF
  }

  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptcontactorEdit.vue